import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateCategory } from "../../api/apiCategories";
import parseError from "../../utils/parseError";

/**
 * Hook لتحديث فئة موجودة
 */
export function useUpdateCategory() {
    const queryClient = useQueryClient();

    const {
        mutate: editCategory,
        isPending: isUpdate,
    } = useMutation({
        mutationFn: ({ id, categoryData }) => updateCategory(id, categoryData),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update category");
        },
    });

    return {
        editCategory,
        isUpdate,
    };
}
